/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {ImmortalFruitsReelController} from "../../reel/ImmortalFruitsReelController";
import {ImmortalFruits} from "../../ImmortalFruits";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ImmortalFruitsGameConfig} from "../../ImmortalFruitsGameConfig";

import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ImmortalFruitsParsedGameData} from "../../server/data/ImmortalFruitsParsedGameData";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";
import {ImmortalFruitsGameModuleConfig} from "../../ImmortalFruitsGameModuleConfig";
import {SoundManager} from "../../resource/sound/SoundManager";

export class ReelStop implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private readonly _reelId: number;
    private _stopDelay: number;
    private _quickStopDelay: number;
    private _nearWinReels:boolean[]=[];
    private _nearBigWinReels:boolean[]=[]
    private _wasBuyFeature:boolean =false;
    public static isAnticipationSoundPlayed : boolean = false;

    /**
     * @constructs
     * @param reelId
     * @param stagger
     * @param abortStagger
     */
    constructor(reelId: number, stagger?: number, abortStagger?: number) {
        this._reelId = reelId;
        this._stopDelay = ImmortalFruits.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = ImmortalFruits.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if (stagger !== undefined) {
            this._stopDelay = stagger;
        }
        if (abortStagger !== undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedGameData): Timeline | null {
        this.stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;
        let reelController:ReelController | null = Reels.getReel(this._reelId);
        reelController?.onGameDataParsed(data);
        return this.stopReel(data, false);
    }

    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: ParsedGameData): Timeline | null {
        return this.stopReel(data, true);
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: ImmortalFruitsParsedGameData): void {
        this._nearWinReels = data.nearWinReels;
        this._nearBigWinReels = data.nearWinBigWinReels;
        if(data.wasFeatureBuy){
            this._nearWinReels = [false,false,false,false,false];
        }
        this._wasBuyFeature = data.wasFeatureBuy;
    }
    /**
     * @description To stop the reel.
     * @param data
     * @param isQuickStop
     */
    private stopReel(data: ParsedGameData, isQuickStop: boolean): Timeline | null {
       let sAnticipationState: ISymbolStateConfig = ImmortalFruitsGameConfig.instance.SYMBOL_STATES.idle;
        let retVal: Timeline | null = ImmortalFruits.timelineReelsController.stopSpin(this._reelId, data, isQuickStop);
        const reelSet: string[] = data.reels[this._reelId];
        let delay = 0;
        if(GameSetting.isFastSpin){
            delay=0.5
        }
        retVal.add(() => (Reels.getReel(this._reelId)! as ImmortalFruitsReelController).reOrderSymbols(), delay);
        retVal.add(() =>{
            if (!isQuickStop ) {
                if ((this._nearWinReels[this._reelId + 1] && this._reelId==3)) {
                    // SoundManager.playAnticipation();
                    ImmortalFruitsGameModuleConfig.nearWinView.playAnimation(this._reelId + 1);
                    ImmortalFruitsGameModuleConfig.nearWinView.fadeInAnimation();
                }
                if(this._nearBigWinReels[this._reelId+1]){
                    ImmortalFruitsGameModuleConfig.nearWinView.playAnimation(this._reelId + 1);
                    ImmortalFruitsGameModuleConfig.nearWinView.fadeInAnimation();
                }
                if(!ReelStop.isAnticipationSoundPlayed && ((this._nearWinReels[this._reelId + 1] && this._reelId==3) || this._nearBigWinReels[this._reelId+1])){
                    ReelStop.isAnticipationSoundPlayed = true;
                    SoundManager.playAnticipation();
                }
            }
            if(data.nextMode == ImmortalFruitsGameMode.BONUS_WHEEL || this._nearWinReels[this._reelId + 1]){
                this.changeStateForScatter(sAnticipationState);
            }
            if (this._reelId === 4 ||(!this._nearWinReels[this._reelId+1] && !this._nearBigWinReels[this._reelId+1])||isQuickStop) {
                ImmortalFruitsGameModuleConfig.nearWinView.stopAllAnimations();
                ImmortalFruitsGameModuleConfig.nearWinView.fadeOutAnimation();
            }
        });
        return retVal;
    };

    /**
     * @description To changes the state of scatter symbol w.r.t. anticipation.
     * @param state
     */
    private changeStateForScatter(state: ISymbolStateConfig): void {
        for (let i = 0; i <= this._reelId; i++) {
            (Reels.getReel(i) as ImmortalFruitsReelController).changeStateForScatter(state);
        }
    }
}